<template>
    <div id="page-user-list">
      <div class="vx-card p-6">
        <div class="flex flex-wrap items-center">
          <!-- ITEMS PER PAGE -->
          <vs-popup classContent="popup-example" title="Manage Lotto" :active.sync="popup">
            <template>
              <div class="vx-row">
                  <div class="vx-col sm:w-2/2 w-full mb-2">
                    <flat-pickr :config="configdateTimePicker" v-model="userSelect.datetime" placeholder="วัน/เวลา" style="width:100%"  />
                  </div>
              </div>
              <!-- <div class="vx-row">
                  <div class="vx-col sm:w-2/2 w-full mb-2">
                      <vs-input class="w-full" label="6 ตัว" v-model="userSelect.six" maxlength="6"/>
                  </div>
              </div> -->
              <div class="vx-row">
                  <div class="vx-col sm:w-2/2 w-full mb-2">
                      <vs-input class="w-full" label="3 ตัว" v-model="userSelect.three" maxlength="3"/>
                  </div>
                  <div class="vx-col sm:w-2/2 w-full mb-2">
                      <vs-input class="w-full" label="2 ตัว" v-model="userSelect.two" maxlength="2"/>
                  </div>
              </div>
            </template>
            <br>
            <vs-button color="primary" type="filled" @click="updateUser">Save</vs-button>&nbsp;&nbsp;&nbsp;
            <vs-button color="dark" type="filled" @click="closePopup">Close</vs-button>
          </vs-popup>
          <div class="flex-grow">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                  <span>30</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <span style="text-align: center;padding-left: 40%;font-size: 20px;">ดาวโจนส์ Star พิเศษ {{ countdown }}</span>
          </div>
  
          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
            <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
            <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
            <vs-button type="filled" @click="addUser()" icon-pack="feather" icon="icon-plus">ADD LOTTO</vs-button>
            <!-- ACTION - DROPDOWN -->
            <!--vs-dropdown vs-trigger-click class="cursor-pointer">
  
              <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
                <span class="mr-2 leading-none">Actions</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
  
              <vs-dropdown-menu>
                <vs-dropdown-item @click="Add()">
                  <span class="flex items-center">
                    <feather-icon icon="UserPlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>Add</span>
                  </span>
                </vs-dropdown-item>
  
                <vs-dropdown-item @click="Delete()">
                  <span class="flex items-center">
                    <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>Delete</span>
                  </span>
                </vs-dropdown-item>
  
                <vs-dropdown-item>
                  <span class="flex items-center">
                    <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>Archive</span>
                  </span>
                </vs-dropdown-item>
  
                <vs-dropdown-item>
                  <span class="flex items-center">
                    <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>Print</span>
                  </span>
                </vs-dropdown-item>
  
                <vs-dropdown-item>
                  <span class="flex items-center">
                    <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>CSV</span>
                  </span>
                </vs-dropdown-item>>
  
              </vs-dropdown-menu>
            </!--vs-dropdown-->
        </div>
  
  
        <!-- AgGrid Table floatingFilter="true"-->
        <!--:onGridReady="onGridReady" -->
        <ag-grid-vue
          ref="agGridTable"
          :components="components"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="usersData"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl"
          >
        </ag-grid-vue>
        <vs-pagination
          :total="totalPages"
          :max="7"
          v-model="currentPage" />
  
      </div>
    </div>
  
  </template>
  
  <script>
  import { AgGridVue } from 'ag-grid-vue'
  import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
  import vSelect from 'vue-select'
  // Store Module
  // Cell Renderer
  import CellRendererLink from './cell-renderer/CellRendererLink.vue'
  import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
  import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
  import CellRendererActions from './cell-renderer/CellRendererActions.vue'
  import CellRendererCreateDate from './cell-renderer/CellRendererCreateDate.vue'
  import CellRendererBank from './cell-renderer/CellRendererBank.vue'
  import moment from "moment-timezone";
  import firebase from 'firebase/app'
  import 'firebase/database'
  import 'firebase/firestore'
  import { createHelpers } from 'vuex-map-fields'
  const { mapFields } = createHelpers({
    getterType: `userManagement/getField`,
    mutationType: `userManagement/updateField`,
  });
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  export default {
    components: {
      AgGridVue,
      vSelect,
      // Cell Renderer
      CellRendererLink,
      CellRendererStatus,
      CellRendererVerified,
      CellRendererActions,
      CellRendererCreateDate,
      CellRendererBank,
      flatPickr
    },
    data () {
      return {
        lotto_id:35,
        lotto_time:'04:45',
        polling:null,
        countdown:'',
        configdateTimePicker: {
          enableTime: true,
          dateFormat: 'Y-m-d H:i',
          enableSeconds: false,
          time_24hr: true,
          // minDate: "today"
          
        },
        userId:'',
        selected: '',
        selectedmenu: '',
        adminsend:'',
        // Filter Options
        roleFilter: { label: 'All', value: 'all' },
        roleOptions: [
          { label: 'All', value: 'all' },
          { label: 'Admin', value: 'admin' },
          { label: 'User', value: 'user' },
          { label: 'Staff', value: 'staff' }
        ],
  
        statusFilter: { label: 'All', value: 'all' },
        statusOptions: [
          { label: 'All', value: 'all' },
          { label: 'Active', value: 'active' },
          { label: 'Deactivated', value: 'deactivated' },
          { label: 'Blocked', value: 'blocked' }
        ],
  
        isVerifiedFilter: { label: 'All', value: 'all' },
        isVerifiedOptions: [
          { label: 'All', value: 'all' },
          { label: 'Yes', value: 'yes' },
          { label: 'No', value: 'no' }
        ],
  
        departmentFilter: { label: 'All', value: 'all' },
        departmentOptions: [
          { label: 'All', value: 'all' },
          { label: 'Sales', value: 'sales' },
          { label: 'Development', value: 'development' },
          { label: 'Management', value: 'management' }
        ],
        searchQuery: '',
  
        // AgGrid
        gridApi: null,
        gridOptions: {
        suppressContextMenu:true,
      },
        defaultColDef: {
          sortable: true,
          editable: true,
          resizable: true,
          suppressMenu: true
        },
        columnDefs: [
          {
            headerName: 'วันที่',
            field: 'datetimeshow',
            filter: true,
            width: 100
          },
          {
            headerName: '3 ตัว',
            field: 'three',
            width: 100,
            filter: true,
          },
          {
            headerName: '2 ตัว',
            field: 'two',
            width: 100,
            filter: true,
          },
          {
            headerName: 'Admin',
            field: 'firstname',
            width: 100,
            filter: true,
          },
          // {
          //   headerName: '5 ตัว',
          //   field: 'five',
          //   width: 100,
          //   filter: true,
          // },
          // {
          //   headerName: '4 ตัว',
          //   field: 'four',
          //   width: 100,
          //   filter: true,
          // },
          /*{
            headerName: 'Line Name',
            field: 'linename',
            filter: true,
            width: 200
          },*/
          // {
          //   headerName: '3 ตัว',
          //   field: 'three',
          //   filter: true,
          //   width: 150
          // },
          // {
          //   headerName: '2 ตัวบน',
          //   field: 'twotop',
          //   filter: true,
          //   width: 350
          // },
          // {
          //   headerName: '2 ตัวล่าง',
          //   field: 'twobottom',
          //   filter: true,
          //   width: 100
          // },
          // {
          //   headerName: '2 ตัวล่าง',
          //   field: 'twobottom',
          //   filter: true,
          //   width: 100
          // },
          {
            headerName: 'แก้ไขข้อมูล',
            field: 'transactions',
            width: 150,
            cellRendererFramework: 'CellRendererActions'
          }
        ],
  
        // Cell Renderer Components
        components: {
          CellRendererCreateDate,
          CellRendererBank,
          CellRendererLink,
          CellRendererStatus,
          CellRendererVerified,
          CellRendererActions
        }
      }
    },
    watch: {
      roleFilter (obj) {
        this.setColumnFilter('role', obj.value)
      },
      statusFilter (obj) {
        this.setColumnFilter('status', obj.value)
      },
      departmentFilter (obj) {
        this.setColumnFilter('department', obj.value)
      },
    },
    computed: {
      ...mapFields([
          'popup',
          'popup2',
      ]),
      userLogin(){
        return this.$store.state.AppActiveUser
      },
      userOption(){
        return this.$store.state.userManagement.userOption
      },
      usersData () {
        return this.$store.state.userManagement.users
      },
      userSelect () {
        if(!this.$store.state.userManagement.user_select.datetime){
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.$store.state.userManagement.user_select.datetime = moment().format('YYYY-MM-DD ')+'04.45'
        }
        return this.$store.state.userManagement.user_select
      },
      paginationPageSize () {
        //if (this.gridApi) return this.gridApi.paginationGetPageSize() else
        return 100
      },
      totalPages () {
        if (this.gridApi) return this.gridApi.paginationGetTotalPages()
        else return 0
      },
      first () {
        return this.$store.state.userManagement.first
      },
      currentPage: {
        get () {
          if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
          else return 1
        },
        set (val) {
          this.gridApi.paginationGoToPage(val - 1)
        }
      }
    },
    methods: {
      renderCountDown(date){
        if(date){
          const date2 = moment.tz(date+":00", "Asia/Bangkok");
          const now = moment().tz("Asia/Bangkok");
          const duration = moment.duration(date2.diff(now));
        // Time calculations for days, hours, minutes and seconds
          var hours = ('0' + duration.hours()).slice(-2)
          var minutes = ('0' + duration.minutes()).slice(-2)
          var seconds = ('0' + duration.seconds()).slice(-2)
          // Display the result in an element with id="demo"
          if(Number(hours) < 0 || Number(minutes) < 0 || Number(seconds) < 0){
            this.$store.dispatch('userManagement/fetchUsersHuay',this.lotto_id).catch(err => { console.error(err) })
          }
          this.countdown = hours + ':' + minutes + ':' + seconds
        }
      },  
      checkUsername(){
        if(!this.userSelect.web){
          alert('Please select web');
          this.userSelect.username = '';
        }
        if(!this.userSelect.key){
          for(const x in this.usersData){
            if(this.usersData[x].username == this.userSelect.username && this.usersData[x].username.trim() && this.usersData[x].web == this.userSelect.web){
              alert('Please recheck username');
              this.userSelect.username = '';
            }
          }
        }
        
      },
      onGridReady(params){
          this.gridApi = params.api;
          this.columnApi = params.columnApi;
          this.gridApi.sizeColumnsToFit();
          window.onresize = () => {
              this.gridApi.sizeColumnsToFit();
          }
      },
      confirmDeleteRecord (data) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm Delete',
          text: `You are about to delete "${data}"`,
          accept: this.deleteRecord,
          acceptText: 'Delete'
        })
      },
      async deleteRecord () {
        for(const data of this.gridApi.getSelectedRows()){
          const emailKey = data.email.trim().replace(/\./g, '||');
          await firebase.database().ref().child(`users/${emailKey}`).remove();
        }
        this.showDeleteSuccess()
        this.$store.dispatch('userManagement/fetchUsersHuay',this.lotto_id).catch(err => { console.error(err) })
      },
      showDeleteSuccess () {
        this.$vs.notify({
          color: 'success',
          title: 'User Deleted',
          text: 'The selected user was successfully deleted'
        })
      },
      Delete(){
        if(this.gridApi.getSelectedRows().length){
          let text = ''
          for(const data of this.gridApi.getSelectedRows()){
            text += (text)?', '+data.firstname:data.firstname
          }
          this.confirmDeleteRecord(text);
        }
      },
      setColumnFilter (column, val) {
        const filter = this.gridApi.getFilterInstance(column)
        let modelObj = null
  
        if (val !== 'all') {
          modelObj = { type: 'equals', filter: val }
        }
  
        filter.setModel(modelObj)
        this.gridApi.onFilterChanged()
      },
      resetColFilters () {
        // Reset Grid Filter
        this.gridApi.setFilterModel(null)
        this.gridApi.onFilterChanged()
  
        // Reset Filter Options
        this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }
  
        this.$refs.filterCard.removeRefreshAnimation()
      },
      updateSearchQuery (val) {
        this.gridApi.setQuickFilter(val)
      },
      async updateUser(){
        this.$vs.loading()
        const datetimes = this.userSelect.datetime.split(' ');
        // const date = datetimes[0].split('-');
        const datetime2 = datetimes[0]+' '+this.lotto_time;
        if(this.userSelect.key){
          const key = (await firebase.database().ref(`/huay/${this.lotto_id}/${this.userSelect.key}`).once('value')).val(); 
          if(key){
            const update = {
                datetime:this.userSelect.datetime,
                datetime2,
                updatedate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
                firstname:this.userLogin.firstname,
            };
            if(this.userSelect.three){
              update.three = this.userSelect.three;
            }
            if(this.userSelect.two){
              update.two = this.userSelect.two;
            }
            await firebase.database().ref('huay/'+this.lotto_id+'/'+this.userSelect.key).update(update).then(()=>{
              this.closePopup();
              this.$store.commit('userManagement/SET_SELECTED', {
                six:'',
                five:'',
                five2:'',
                four:'',
                three:'',
                twotop:'',
                twobottom:'',
                datetime:'',
                datetime2:'',
                three2:'',
                two:'',
                two2:'',
                key:'',
              });
              this.$store.dispatch('userManagement/fetchUsersHuay',this.lotto_id).catch(err => { console.error(err) }).then(()=>{
                this.$vs.loading.close();
              })
            });
          }else{
            alert('Please recheck key');
          }
        }else{
            const yesterdays = (await firebase.database().ref(`/huay/${this.lotto_id}`).orderByChild('datetime').equalTo(moment(this.userSelect.datetime).tz("Asia/Bangkok").add(-1,'days').format('YYYY-MM-DD')+' '+this.lotto_time).once('value')).val(); 
            let yesterday;
            for(const x in yesterdays){
                yesterday = yesterdays[x];
            }
            const _max = this.randomNumber(100,2000,true);
            const _min = this.randomNumber(100,2000,true);
            const max = ((Number(yesterday.threeall2)+Number(_max))).toFixed(2);
            const min = (Number(yesterday.threeall2)-Number(_min)).toFixed(2);
            const _threeall = this.randomNumber(min,max,true);
            const threeall = _threeall.toString().substring(0, _threeall.toString().length - 4)+''+this.userSelect.three.toString().charAt(0)+'.'+this.userSelect.three.toString().charAt(1)+''+this.userSelect.three.toString().charAt(2);
            const twoall = Math.floor(Number(threeall) - Number(yesterday.threeall2))+'.'+this.userSelect.two;
            const three =  threeall.toString().substring(threeall.toString().length-4).replace('.','');
            const two =  twoall.toString().split('.')[1];
            const change = ((Number(threeall) - Number(yesterday.threeall2)) / Number(yesterday.threeall2) * 100).toFixed(2);
            await firebase.database().ref('huay/'+this.lotto_id).push({
                three,
                threeall,
                two,
                twoall,
                datetime:this.userSelect.datetime,
                updatedate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
                firstname:this.userLogin.firstname,
                open:(yesterday && yesterday.threeall2)?yesterday.threeall2:'',
                max,
                min,
                volumn:this.randomNumber(300,800,false),
                change
            }).then(()=>{
              this.closePopup();
              this.$store.commit('userManagement/SET_SELECTED', {
                six:'',
                five:'',
                five2:'',
                four:'',
                three:'',
                twotop:'',
                twobottom:'',
                datetime:'',
                datetime2:'',
                three2:'',
                two:'',
                two2:'',
                key:'',
              });
              this.$store.dispatch('userManagement/fetchUsersHuay',this.lotto_id).catch(err => { console.error(err) }).then(()=>{
                this.$vs.loading.close();
              })
            });
        }
      },
      addUser(){
        this.$store.commit('userManagement/SET_SELECTED', {
          six:'',
          five:'',
          five2:'',
          four:'',
          three:'',
          twotop:'',
          twobottom:'',
          datetime:'',
          datetime2:'',
          three2:'',
          two:'',
          two2:'',
          key:'',
        });
        this.$store.commit('userManagement/SET_POPUP', true);
      },
      randomNumber(min,max,decimal){
        if(decimal)
            return (Math.random() * (Number(max) - Number(min)) + Number(min)).toFixed(2);
        else
            return Math.floor(Math.random() * (Number(max) - Number(min) + 1)) + Number(min);
      },
      closePopup(){
         this.$store.commit('userManagement/SET_POPUP', false);
         this.$store.commit('userManagement/SET_POPUP2', false);
      },
    },
    mounted () {
      this.gridApi = this.gridOptions.api
      if(window.innerWidth>1000)
      setTimeout( ()=> this.gridApi.sizeColumnsToFit(), 0 );
      /* =================================================================
        NOTE:
        Header is not aligned properly in RTL version of agGrid table.
        However, we given fix to this issue. If you want more robust solution please contact them at gitHub
      ================================================================= */
      
      if (this.$vs.rtl) {
        const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
        header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
      }
    },
    beforeDestroy () {
    clearInterval(this.polling)
  },
    async created () {
      this.$vs.loading()
      this.$store.commit('userManagement/SET_FIRST', '');
      this.$store.commit('userManagement/SET_USERS', []);
      this.$store.commit('userManagement/SET_SELECTED', {
        six:'',
        five:'',
        five2:'',
        four:'',
        three:'',
        twotop:'',
        twobottom:'',
        datetime:'',
        datetime2:'',
        three2:'',
        two:'',
        two2:'',
        key:'',
      });
    //     for(let i=21;i>0;i--){
    //         const datetime = moment().tz("Asia/Bangkok").add(-i,'days').format('YYYY-MM-DD')+' '+this.lotto_time;
    //         console.log(datetime);
    //         const yesterdays = (await firebase.database().ref(`/huay/${this.lotto_id}`).orderByChild('datetime').equalTo(moment(datetime).tz("Asia/Bangkok").add(-1,'days').format('YYYY-MM-DD')+' '+this.lotto_time).once('value')).val(); 
    //         let yesterday;
    //         for(const x in yesterdays){
    //             yesterday = yesterdays[x];
    //         }
    //         if(!yesterday){
    //             yesterday = {
    //                 threeall:35000,
    //             }
    //         }
    //         const _max = this.randomNumber(100,300,true);
    //         const _min = this.randomNumber(100,300,true);
    //         const max = Number(yesterday.threeall)+Number(_max);
    //         const min = Number(yesterday.threeall)-Number(_min);
    //         const threeall = this.randomNumber(min,max,true);
    //         const twoall = (Number(threeall) - Number(yesterday.threeall)).toFixed(2);
    //         const three =  threeall.toString().substring(threeall.toString().length-4).replace('.','');
    //         const two =  twoall.toString().split('.')[1];
    //         const change = ((Number(threeall) - Number(yesterday.threeall)) / Number(yesterday.threeall) * 100).toFixed(2);
    //         console.log('threeall',threeall);
    //         console.log('twoall',twoall);
    //         console.log('three',three);
    //         console.log('two',two);
    //         console.log('change',change);
    //         firebase.database().ref('huay/'+this.lotto_id).push({
    //           three,
    //           threeall,
    //           two,
    //           twoall,
    //           datetime,
    //           updatedate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    //           firstname:'Auto',
    //           open:(yesterday && yesterday.threeall)?yesterday.threeall:'',
    //           max,
    //           min,
    //           volumn:this.randomNumber(300,800,false),
    //           change,
    //           amount100m:this.randomNumber(10,100,true),
    //           volumnmil:this.randomNumber(100,600,true),
    //           amount100mil:this.randomNumber(2000,6000,true),
    //           volumn10bil:this.randomNumber(1,3,true),
    //         })
    //     // }
    //   }
      this.$store.dispatch('userManagement/fetchUsersHuay',this.lotto_id).catch(err => { console.error(err) }).then(()=>{
        setTimeout(() => {
          this.$vs.loading.close()    
        }, 1000);
      });
      this.polling = setInterval( ()=> {  this.renderCountDown(this.first); }, 1000 );  
    }
  }
  
  </script>
  
  <style lang="scss">
  #page-user-list {
    .user-list-filters {
      .vs__actions {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-58%);
      }
    }
  }
  </style>
  